const AUTHORS = {
  SET_AUTHORS_QUERY: 'SET_AUTHORS_QUERY',

};

export default AUTHORS;
